module.exports = __webpack_public_path__ + "static/media/about_abtest_mo_en.5da56937.png";